
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {FaRating} from 'vue-rate-it'
import ThumbsUp from 'vue-rate-it/glyphs/thumbs-up'

@Component({
  components: {
    FaRating
  }
})
export default class ProspectPanel extends Vue {
  @Prop(Object) data!: any

  thumbsUp = null

  get icon() {
    return this.thumbsUp
  }

  created() {
    this.thumbsUp = ThumbsUp
  }

  hasOptions(item) {
    return (
      item.PROPOSITION_SECRETARIAT === 1 ||
      item.PROPOSITION_EMPLOYES === 1 ||
      item.PROPOSITION_COACHING === 1 ||
      item.PROPOSITION_AUDIT === 1 ||
      item.PROPOSITION_DEMARRAGE === 1 ||
      item.PROPOSITION_ASSISTANCE_INCLUSE === 1
    )
  }

  getOptions(item) {
    const p = []
    if (item.PROPOSITION_SECRETARIAT === 1) p.push(' Secrétariat')
    if (item.PROPOSITION_EMPLOYES === 1) p.push(' Employés')
    if (item.PROPOSITION_COACHING === 1) p.push(' Coaching')
    if (item.PROPOSITION_AUDIT === 1) p.push(' Audit')
    if (item.PROPOSITION_DEMARRAGE === 1) p.push(' Démarrage')
    if (item.PROPOSITION_ASSISTANCE_INCLUSE === 1) p.push(' Assistance incluse')
    return p.toString()
  }

  onCloseHandler() {
    this.$emit('closePanel', {})
  }
}
